import {
  ALERT_SUCCESS, ALERT_ERROR, ALERT_CLEAR
} from '../actions/alerts';

const INITIAL_STATE = {message: null, type: null};

let alertsReducer = (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case ALERT_SUCCESS:
      return {
        ...state,
        message: action.message,
        type: 'success'
      }; 
    case ALERT_ERROR:
      return { 
        ...state, 
        message: action.message,
        type: 'error'
      };
    case ALERT_CLEAR:
      return { 
        ...state, 
        message: '',
        type: ''
      };
    default:
      return state;
  }
}

export default alertsReducer
